export enum ErrorHandlerType {
    NO_INTERNET = 'NO_INTERNET',
    NETWORK_ERROR = 'NETWORK_ERROR',
    GEOLOCATION_ERROR = 'GEOLOCATION_ERROR',
    NOT_FOUND = 'NOT_FOUND',
  }
  
  export interface ErrorHandlerProps {
    error: ErrorHandlerType | undefined;
  }  